<template>
  <div class="box3">
    <pageTitle title="不可错过北亚利桑那大学的理由" />
    <div class="subject-content">
      <img src="../../../assets/coursePage/nau/box3/img01.png"/>
    </div>
    <a  @click="zixun('加入NAU与比尔·盖茨做校友')" class="btn">加入NAU&nbsp;&nbsp;与比尔·盖茨做校友</a>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  methods: {
    zixun(name) {
      zhuge.track("H5_北亚利桑那大学专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box3 {
  padding: 80px 0 48px;
  width: 100%;
  background: url("../../../assets/coursePage/java/box3/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .subject-content {
   padding:0 16px 16px 16px;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 1888px;
  margin-top: 48px ;
    img{
      width: 996px;
      margin-right: 16px;
    }
  }
  .btn{
    width: calc(100% - 64px);
    margin: 16px auto 0;
    height: 96px;
    background: linear-gradient( 224deg, #86BAFF 0%, #476DDF 100%);
    border-radius: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 96px;
    text-align: center;
    font-style: normal;
    display:block;
  }
}
</style>
